
 import React from 'react';
 import { connect } from 'react-redux';
 const LoaderSpinner = (props) => {

    return <>
    {props.loader && <><div className="spinner-bg" role="load">
     <ul className="spinner">
          <li className="bounce1"></li>
          <li className="bounce2"></li>
          <li className="bounce3"></li>
        </ul>
      </div> </>
 }
</>

 }

 export default connect(null, null)(LoaderSpinner);